import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Container, Form, Button } from "react-bootstrap";
import ComponentMenu from "../../components/layout/ComponentMenu";
import ComponentTitle from "../../components/layout/ComponentTitle";
import ComponentLoader from "../../components/layout/ComponentLoader";
import {
  apiGetVisualmanagements,
  apiSaveVisualmanagement,
  apiUpdateVisualmanagement,
  apiDeleteVisualmanagement,
} from "../../api/ApiVisualmanagement";

const PageAdminVisualManagement = () => {
  const { t } = useTranslation();
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const initialState = { url: "" };
  const [state, setState] = useState(initialState);
  const [loader, setLoader] = useState(false);

  const recupDatas = async () => {
    const res = await apiGetVisualmanagements(ReduxInstance._id);
    if (res.data[0]) setState(res.data[0]);
    else setState(initialState);
  };

  const deleteData = async () => {
    setLoader(true);
    await apiDeleteVisualmanagement(state._id);
    await recupDatas();
    setLoader(false);
  };

  const submitDatas = async (e) => {
    setLoader(true);
    e.preventDefault();
    if (state._id) {
      await apiUpdateVisualmanagement(state._id, state);
    } else {
      await apiSaveVisualmanagement(ReduxInstance._id, state);
    }
    recupDatas();
    setLoader(false);
  };

  useEffect(() => {
    recupDatas();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <>
      <ComponentMenu />
      <Container>
        <ComponentTitle title={t("admin.PageAdminVisualManagement.titre")} />
        <Form onSubmit={submitDatas}>
          <label className="fw-bold mt-2">{t("commun.form.label.urlConsultation")}</label>
          <Form.Control
            type="text"
            name="url"
            placeholder={t("commun.form.placeholder.url")}
            value={state.url}
            onChange={(e) => setState({ ...state, [e.target.name]: e.target.value })}
          />
          <div className="text-end mb-5 mt-2">
            {!loader && (
              <>
                {state._id && (
                  <Button variant="danger" onClick={deleteData} className="me-2">
                    {t("commun.form.button.supprimer")}
                  </Button>
                )}
                <Button variant="success" type="Submit">
                  {state._id
                    ? t("commun.form.button.modifier")
                    : t("commun.form.button.enregistrer")}
                </Button>
              </>
            )}
            {loader && <ComponentLoader />}
          </div>
        </Form>
      </Container>
    </>
  );
};

export default PageAdminVisualManagement;
